import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { useSimplesNacional } from '@/contexts/SimplesNacionalContext';
import { useAlterarSegmento } from '@/services/SimplesNacional/Segregacao/hooks/useAlterarSegmento';

const SEGMENTOS = [
  { id: '0', label: '0 — Não Definido' },
  { id: '1', label: '1 — Alimentos e Bebidas' },
  { id: '2', label: '2 — Têxteis e Vestuário' },
  { id: '4', label: '4 — Eletrônicos e Eletrodomésticos' },
  { id: '44', label: '44 — Ferragens, Vidros e Materiais de Construção' },
  { id: '57', label: '57 — Papelaria e Escritório' },
  { id: '63', label: '63 — Brinquedos e Jogos' },
  { id: '65', label: '65 — Higiene e Beleza' },
  { id: '66', label: '66 — Saúde' },
  { id: '67', label: '67 — Automotivo' },
  { id: '68', label: '68 — Outros' },
];

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  produtos: string[];
  onSuccess?: () => void;
}

export function AlterarSegmentoDialog({ open, onOpenChange, produtos, onSuccess }: Props) {
  const [segmento, setSegmento] = useState('');
  const { cnpjContribuinte } = useSimplesNacional();
  const { mutate, isPending } = useAlterarSegmento();

  const handleConfirmar = () => {
    if (!segmento || !cnpjContribuinte) return;
    mutate(
      { CNPJ_Contribuinte: cnpjContribuinte, Segmento: segmento, Produtos: produtos },
      {
        onSuccess: () => {
          onOpenChange(false);
          setSegmento('');
          onSuccess?.();
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Alterar Segmento</DialogTitle>
          <DialogDescription>
            {produtos.length} produto(s) selecionado(s). Escolha o novo Segmento.
          </DialogDescription>
        </DialogHeader>

        <Select value={segmento} onValueChange={setSegmento}>
          <SelectTrigger>
            <SelectValue placeholder="Selecionar Segmento..." />
          </SelectTrigger>
          <SelectContent>
            {SEGMENTOS.map(s => (
              <SelectItem key={s.id} value={s.id}>
                {s.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Cancelar
          </Button>
          <Button onClick={handleConfirmar} disabled={!segmento || isPending}>
            {isPending ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Confirmar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
